"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledButton = _interopRequireDefault(require("../../buttons/styledButton"));

var _constants = require("../../../assets/js/constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GiftWrapper = _styledComponents["default"].div.withConfig({
  displayName: "gift__GiftWrapper",
  componentId: "sc-16ujt06-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: relative;\n    width: 31%;\n    background: #fff;\n    border: 1px solid ", ";\n    border-radius: 4px;\n    display: flex;\n    flex-direction: column;\n    font-family: ", ";\n    transition: box-shadow 0.2s linear;\n    overflow: hidden;\n    &:hover {\n        box-shadow: 0 0 20px rgba(0,0,0,0.15);\n    }\n    @media (max-width: 1280px) {\n        width: 48%;\n    }\n    @media (max-width: 760px) {\n        width: 100%;\n        max-width: 400px;\n    }\n"])), _constants.COLORS.lightGrey, _constants.FONTS.regular);

var GiftImg = _styledComponents["default"].div.withConfig({
  displayName: "gift__GiftImg",
  componentId: "sc-16ujt06-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 200px;\n    width: 100%;\n    background: url(", ") no-repeat;\n    background-size: cover;\n    background-position: center;\n"])), function (props) {
  return props.src;
});

var GiftDate = _styledComponents["default"].div.withConfig({
  displayName: "gift__GiftDate",
  componentId: "sc-16ujt06-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 14px;\n    font-family: ", ";\n    height: 20px;\n"])), _constants.FONTS.light);

var GiftContent = _styledComponents["default"].div.withConfig({
  displayName: "gift__GiftContent",
  componentId: "sc-16ujt06-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    padding: 30px;\n    justify-content: space-between;\n    width: 100%;\n    height: calc(100% - 200px);\n    @media (max-width: 800px) { \n        padding: 30px 20px;\n    }\n"])));

var GiftBlock = _styledComponents["default"].div.withConfig({
  displayName: "gift__GiftBlock",
  componentId: "sc-16ujt06-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: block;\n    width: 100%;\n"])));

var Content = _styledComponents["default"].div.withConfig({
  displayName: "gift__Content",
  componentId: "sc-16ujt06-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    justify-content: flex-end;\n    margin-top: 20px;\n"])));

var GiftTitle = _styledComponents["default"].div.withConfig({
  displayName: "gift__GiftTitle",
  componentId: "sc-16ujt06-6"
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: 20px;\n    line-height: 28px;\n    margin-top: 7px;\n    @media (max-width: 800px) { \n        line-height: 22px;\n    }\n"])));

var GiftDesc = _styledComponents["default"].div.withConfig({
  displayName: "gift__GiftDesc",
  componentId: "sc-16ujt06-7"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    margin-top: 10px;\n    color: ", ";\n    font-family: ", ";\n    line-height: normal;\n"])), _constants.COLORS.darkGrey, _constants.FONTS.light);

var EndText = _styledComponents["default"].p.withConfig({
  displayName: "gift__EndText",
  componentId: "sc-16ujt06-8"
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    font-size: 16px;\n    font-family: ", ";\n    margin: 0 0 10px;\n"])), _constants.FONTS.light);

var NewOffer = _styledComponents["default"].div.withConfig({
  displayName: "gift__NewOffer",
  componentId: "sc-16ujt06-9"
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 20px;\n    left: 20px;\n    background: #DB5858;\n    border-radius: 2px;\n    color: #fff;\n    font-size: 14px;\n    line-height: 14px;\n    padding: 5px 10px;\n"])));

var Gift = /*#__PURE__*/function (_React$Component) {
  _inherits(Gift, _React$Component);

  var _super = _createSuper(Gift);

  function Gift() {
    _classCallCheck(this, Gift);

    return _super.apply(this, arguments);
  }

  _createClass(Gift, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          img = _this$props.img,
          date = _this$props.date,
          title = _this$props.title,
          desc = _this$props.desc,
          endDate = _this$props.endDate,
          isConnected = _this$props.isConnected,
          newOffer = _this$props.newOffer,
          buttonText = _this$props.buttonText,
          connect = _this$props.connect,
          disconnect = _this$props.disconnect,
          disconnectTextButton = _this$props.disconnectTextButton,
          rest = _objectWithoutProperties(_this$props, ["img", "date", "title", "desc", "endDate", "isConnected", "newOffer", "buttonText", "connect", "disconnect", "disconnectTextButton"]);

      var content = isConnected ? /*#__PURE__*/_react["default"].createElement(Content, null, endDate ? /*#__PURE__*/_react["default"].createElement(EndText, null, "\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 ", endDate) : null, /*#__PURE__*/_react["default"].createElement(_styledButton["default"], {
        type: "error",
        text: disconnectTextButton,
        onClick: disconnect
      })) : /*#__PURE__*/_react["default"].createElement(Content, null, /*#__PURE__*/_react["default"].createElement(_styledButton["default"], {
        type: "primary",
        text: buttonText,
        onClick: connect
      }));
      return /*#__PURE__*/_react["default"].createElement(GiftWrapper, rest, newOffer ? /*#__PURE__*/_react["default"].createElement(NewOffer, null, "\u041D\u041E\u0412\u0418\u041D\u041A\u0410") : null, /*#__PURE__*/_react["default"].createElement(GiftImg, {
        src: img
      }), /*#__PURE__*/_react["default"].createElement(GiftContent, null, /*#__PURE__*/_react["default"].createElement(GiftBlock, null, /*#__PURE__*/_react["default"].createElement(GiftDate, null, date), /*#__PURE__*/_react["default"].createElement(GiftTitle, null, title), /*#__PURE__*/_react["default"].createElement(GiftDesc, {
        dangerouslySetInnerHTML: {
          __html: desc
        }
      })), content));
    }
  }]);

  return Gift;
}(_react["default"].Component);

exports["default"] = Gift;

_defineProperty(Gift, "propTypes", {
  img: _propTypes["default"].string,
  date: _propTypes["default"].string,
  title: _propTypes["default"].string,
  desc: _propTypes["default"].string,
  endDate: _propTypes["default"].string,
  isConnected: _propTypes["default"].bool,
  newOffer: _propTypes["default"].bool,
  buttonText: _propTypes["default"].string,
  connect: _propTypes["default"].func,
  disconnect: _propTypes["default"].func,
  disconnectTextButton: _propTypes["default"].string
});

_defineProperty(Gift, "defaultProps", {
  title: '',
  desc: '',
  connect: function connect() {},
  disconnect: function disconnect() {},
  buttonText: 'Подключить',
  newOffer: false,
  isConnected: false,
  disconnectTextButton: 'Подробнее'
});